var map = {
	"./chitwan1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/chitwan1.ogg",
	"./chitwan2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/chitwan2.ogg",
	"./chitwan3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/chitwan3.ogg",
	"./chitwan4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/chitwan4.ogg",
	"./conclusion1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/conclusion1.ogg",
	"./conclusion2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/conclusion2.ogg",
	"./dailekh1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dailekh1.ogg",
	"./dailekh2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dailekh2.ogg",
	"./dailekh3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dailekh3.ogg",
	"./dailekh4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dailekh4.ogg",
	"./dolakha1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolakha1.ogg",
	"./dolakha2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolakha2.ogg",
	"./dolakha3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolakha3.ogg",
	"./dolakha4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolakha4.ogg",
	"./dolpa1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolpa1.ogg",
	"./dolpa2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolpa2.ogg",
	"./dolpa3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolpa3.ogg",
	"./dolpa4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolpa4.ogg",
	"./dolpa5.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/dolpa5.ogg",
	"./jhapa1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/jhapa1.ogg",
	"./jhapa2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/jhapa2.ogg",
	"./jhapa3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/jhapa3.ogg",
	"./jhapa4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/jhapa4.ogg",
	"./kanchanpur1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kanchanpur1.ogg",
	"./kanchanpur2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kanchanpur2.ogg",
	"./kanchanpur3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kanchanpur3.ogg",
	"./kathmandu1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kathmandu1.ogg",
	"./kathmandu2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kathmandu2.ogg",
	"./kathmandu3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kathmandu3.ogg",
	"./kathmandu4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/kathmandu4.ogg",
	"./khotang1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/khotang1.ogg",
	"./khotang2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/khotang2.ogg",
	"./khotang3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/khotang3.ogg",
	"./khotang4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/khotang4.ogg",
	"./saptari1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/saptari1.ogg",
	"./saptari2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/saptari2.ogg",
	"./saptari3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/saptari3.ogg",
	"./saptari4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/saptari4.ogg",
	"./sound_eff/blank.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/sound_eff/blank.ogg",
	"./sound_eff/bus.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/sound_eff/bus.ogg",
	"./sound_eff/bus2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/sound_eff/bus2.ogg",
	"./sound_eff/citymusic.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/sound_eff/citymusic.ogg",
	"./sound_eff/jungle.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/sound_eff/jungle.ogg",
	"./starting1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/starting1.ogg",
	"./starting2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/starting2.ogg",
	"./starting3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/starting3.ogg",
	"./surkhet1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/surkhet1.ogg",
	"./surkhet2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/surkhet2.ogg",
	"./surkhet3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/surkhet3.ogg",
	"./surkhet4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/surkhet4.ogg",
	"./tapleyjung1.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/tapleyjung1.ogg",
	"./tapleyjung2.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/tapleyjung2.ogg",
	"./tapleyjung3.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/tapleyjung3.ogg",
	"./tapleyjung4.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/tapleyjung4.ogg",
	"./timi_k_khanchau.ogg": "./src/EGRContent/Story/TimiKKhanchau/audios/timi_k_khanchau.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/TimiKKhanchau/audios sync recursive ^\\.\\/.*$";